<template>
  <div class="trainings-view-page mt-4">
    <app-page-header title="Treinamento"></app-page-header>

    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <div v-if="!isLoading" class="training">
            <div class="training__image">
              <div class="points">
                <p>{{ training.points }}</p>
                <p>pontos</p>
              </div>
              <img :src="training.image" alt="Imagem de Treinamento" />
            </div>
            <div class="training__content">
              <h1 class="title">{{ training.title }}</h1>
              <p class="updated_at">
                Atualizado em:
                <span>{{ training.updated_at | date }}</span>
              </p>
              <div class="buttons">
                <a :href="training.midia" target="_blank">
                  <button type="button" v-app-button>
                    INICIAR TREINAMENTO
                  </button>
                </a>
                <router-link
                  :to="{
                    name: 'site.trainings.answer',
                    params: { id: training.id },
                  }"
                  :disabled="training.is_done"
                  tag="button"
                  class="app-button secondary"
                  >{{ buttonText }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrainingService from '@/services/training.service';

export default {
  name: 'trainings-view-page',
  data: () => {
    return {
      isLoading: true,
      training: {},
    };
  },
  computed: {
    buttonText() {
      const { is_done, question_count } = this.training;

      return is_done
        ? `${question_count}/${question_count} ACERTOS`
        : 'RESPONDER O TESTE';
    },
  },
  methods: {
    loadTraining(id) {
      TrainingService.getId(id)
        .then(({ data: training }) => (this.training = training))
        .finally(() => (this.isLoading = false));
    },
  },
  beforeMount() {
    const id = this.$route.params.id;
    id && this.loadTraining(id);
  },
};
</script>

<style lang="scss" scoped>
.col-12.text-center {
  text-align: center;
}

.training {
  display: inline-flex;
  text-align: left;

  &__image {
    position: relative;
    margin-right: 16px;

    .points {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: absolute;
      left: -30px;
      top: -30px;
      background: var(--color-primary);
      color: #fff;
      border-radius: 50%;
      text-align: center;
      height: 60px;
      width: 60px;
      line-height: 1.2;

      p {
        &:first-child {
          font-size: 1.2em;
          font-weight: bold;
        }

        &:last-child {
          font-size: 0.8em;
        }
      }
    }

    img {
      object-fit: cover;
      max-width: 720px;
      width: 100%;
    }
  }

  &__content {
    .title {
      color: var(--color-primary);
      font-weight: bold;
    }

    .updated_at {
      color: var(--text-color-light);
      font-weight: bold;

      span {
        font-weight: normal;
      }
    }

    .buttons {
      margin-top: 16px;

      button:first-child {
        margin-right: 16px;
      }
    }
  }
}

@media (max-width: 992px) {
  .training {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 1em;

    &__image { 
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      width: 100%;
      max-width: 400px;

      .points {
        left: calc(50% - 30px);
      }
    }

    .buttons {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        width: 100%;
      }

      button {
        margin-bottom: 1em;
        width: 100%;
      }

      button:first-child {
        margin-right: 0;
      }
    }
  }
}
</style>
